// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__1MNGk","label":"Category_label__3lkXr","content":"Category_content__26iVq","header":"Category_header__zhjRN","location":"Category_location__29k--"};